var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', {
    staticClass: "groupRuleEdit"
  }, [_vm.editing ? [_c('span', {
    staticClass: "humanReadableRuleEditor"
  }, [_vm.RelationIsSpecial(_vm.rule.relation) ? [_vm.rule.relation === 'total_price' ? [_c('span', [_vm._v(" Het "), _c('strong', [_vm._v("totaalbedrag")]), _vm._v(" van de order "), _c('b-form-select', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "options": _vm.GetAvailableOperators(_vm.rule.relation),
      "size": "sm"
    },
    model: {
      value: _vm.rule.operator,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "operator", $$v);
      },
      expression: "rule.operator"
    }
  }), _c('b-form-input', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "64px"
    },
    attrs: {
      "size": "sm",
      "type": "number"
    },
    model: {
      value: _vm.rule.value,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "value", $$v);
      },
      expression: "rule.value"
    }
  }), _vm._v(" euro ")], 1)] : _vm.rule.relation === 'sales_order_lines' ? [_c('span', [_vm._v("Er is een orderregel met een "), _c('strong', [_vm._v("aantal dat "), _c('b-form-select', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "320px"
    },
    attrs: {
      "options": _vm.GetAvailableOperators(_vm.rule.relation),
      "size": "sm",
      "type": "number"
    },
    model: {
      value: _vm.rule.operator,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "operator", $$v);
      },
      expression: "rule.operator"
    }
  }), _c('b-form-input', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "64px"
    },
    attrs: {
      "size": "sm",
      "type": "number"
    },
    model: {
      value: _vm.rule.value,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "value", $$v);
      },
      expression: "rule.value"
    }
  })], 1)])] : _vm.rule.relation === 'hours_between_same_order' ? [_c('span', [_vm._v(" Er zijn "), _c('b-form-input', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "64px"
    },
    attrs: {
      "size": "sm",
      "type": "number"
    },
    model: {
      value: _vm.rule.value,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "value", $$v);
      },
      expression: "rule.value"
    }
  }), _vm._v(" uur of minder tussen twee bestellingen van dezelfde klant")], 1)] : [_c('GroupRule', {
    attrs: {
      "rule": _vm.rule
    }
  })]] : [_vm._v(" uit "), _c('b-form-select', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "options": _vm.Relations,
      "size": "sm"
    },
    model: {
      value: _vm.rule.relation,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "relation", $$v);
      },
      expression: "rule.relation"
    }
  }), _vm._v(" de waarde van "), _c('b-form-select', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "options": _vm.GetAvailableFields(_vm.rule.relation),
      "size": "sm"
    },
    model: {
      value: _vm.rule.field,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "field", $$v);
      },
      expression: "rule.field"
    }
  }), _c('b-form-select', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "options": _vm.GetAvailableOperators(_vm.rule.relation),
      "size": "sm"
    },
    model: {
      value: _vm.rule.operator,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "operator", $$v);
      },
      expression: "rule.operator"
    }
  }), _c('b-form-input', {
    staticClass: "d-inline-block mx-2",
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "sm"
    },
    model: {
      value: _vm.rule.value,
      callback: function ($$v) {
        _vm.$set(_vm.rule, "value", $$v);
      },
      expression: "rule.value"
    }
  })]], 2)] : [_c('GroupRule', {
    attrs: {
      "rule": _vm.rule
    }
  })]], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }